import { environment } from '@bakerweb/client-environment';
import axios, { AxiosRequestConfig } from 'axios';
import { getRestAuthToken } from './rest-auth-token';

export const clientHttp = async (urlFragment: string, options: AxiosRequestConfig = {}) => {
  try {
    const token = await getRestAuthToken();

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`
    };

    const response = await axios({
      url: `${environment.baseHttpUrl}${urlFragment}`,
      method: options.method || 'POST',
      headers,
      data: options.data || null,
      params: options.params || null,
      ...options
    });

    return response.data;
  } catch (error) {
    console.error('HTTP Request Error:', error);
    throw error;
  }
};
